/**
 * The R2 binding table. Devices are data, not code: the controller reads this
 * structure and knows nothing about which key or pad button is which.
 */
export type R2Action = 'up' | 'down' | 'left' | 'right' | 'fire';

export interface InputMapping {
  /** KeyboardEvent.code -> action. Codes, not keys, so layout does not matter. */
  readonly keyboard: Readonly<Record<string, R2Action>>;
  /** Standard-mapping button indices; an analog trigger counts as pressed past BUTTON_VALUE_THRESHOLD. */
  readonly gamepadButtons: Readonly<Partial<Record<R2Action, readonly number[]>>>;
  readonly gamepadAxes: { readonly moveX: number; readonly moveY: number; readonly deadZone: number };
}

/** Triggers (button 7) report a continuous value and never set `pressed` on some pads. */
export const BUTTON_VALUE_THRESHOLD = 0.25;

const STICK_DEAD_ZONE = 0.2;

export const DEFAULT_INPUT_MAPPING: InputMapping = Object.freeze({
  keyboard: Object.freeze({
    ArrowUp: 'up',
    KeyW: 'up',
    ArrowDown: 'down',
    KeyS: 'down',
    ArrowLeft: 'left',
    KeyA: 'left',
    ArrowRight: 'right',
    KeyD: 'right',
    Space: 'fire',
    KeyJ: 'fire',
  } satisfies Record<string, R2Action>),
  gamepadButtons: Object.freeze({
    up: Object.freeze([12]),
    down: Object.freeze([13]),
    left: Object.freeze([14]),
    right: Object.freeze([15]),
    fire: Object.freeze([0, 7]),
  }),
  gamepadAxes: Object.freeze({ moveX: 0, moveY: 1, deadZone: STICK_DEAD_ZONE }),
});
